export const environment = {
  production: true,
  //Afiliaciones
  baseUrlAPi:                 'https://afiliaciones.api.focunti.com',
  apiUrlAfiliacion:           'https://afiliaciones.api.focunti.com/afiliacion',
  apiUrlAfiliacionDocumento:  'https://afiliaciones.api.focunti.com/afiliacion_documento/',
  
  //nómina
  apiUrlNomina: 'https://nomina.api.focunti.com/nomina/',

  //SST
  apiUrlSst: 'https://sst.api.focunti.com/sst/',

  //Gestión de procesos
  apiUrlContratacion: 'https://contratacion.api.focunti.com/contratacion',
  baseUrlAWS: 'https://api.focunti.com',

  //entidades
  apiUrlEntidad: 'https://entidad.api.focunti.com/entidad',
  apiUrlApp: 'https://admin-prod.focunti.com/app/',

  //cliente
  apiUrlClientes: 'https://clientes.api.focunti.com/cliente',

  //empleado/documento/beneficiario
  apiUrlEmpleados: 'https://empleados.api.focunti.com/empleado',
  apiUrlDocumentos: 'https://empleados.api.focunti.com/documento',
  apiUrlBeneficiarios: 'https://empleados.api.focunti.com/beneficiario/',

  wsOnboardingUrl: 'wss://ws.focunti.com',
  mocks:false,
  
  msalConfig: {
    clientId: '41b07dfe-43d2-486a-abd0-3b6ffd5b36fd',
    redirectUri: 'https://plataforma.hurclick.com',
    postLogoutRedirectUri: 'https://plataforma.hurclick.com'
  }
};
